exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-button-menu[data-v-6b772d0e]{background-color:#e30613!important;padding:0 25px;height:40px;margin-top:10px;margin-left:10px;color:#fff!important}", ""]);

// exports
